import { bizRequest } from "../../bizClient"; // Import the API helper

const getLocationsForStationMapper = async (customerId) => {
	let url = `/api/locations/getLocationsWithStationMapper/${customerId}`;
	return await bizRequest(url)
		.then(data => {
			return data;
		})
		.catch((error) => {
			console.error('Something went wrong fetching locations for Station Mapper', error);
			throw error;
		});
}

export {
	getLocationsForStationMapper
}
